"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { commonApiFetch } from "@/services/api/common-api";
import type { ApiWaveDropsFeed } from "@/generated/models/ApiWaveDropsFeed";
import type { ApiDropWithoutWave } from "@/generated/models/ApiDropWithoutWave";
import { buildProcessedContent } from "@/components/waves/drops/media-utils";
import type { ProcessedContent } from "@/components/waves/drops/media-utils";
export function useWaveLatestDrop(waveId, t0) {
  const $ = _c(7);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  let t2;
  if ($[0] !== waveId) {
    t1 = ["wave-latest-drop", waveId];
    t2 = async () => {
      const data = await commonApiFetch({
        endpoint: `waves/${waveId}/drops`,
        params: {
          limit: "1"
        }
      });
      return data.drops[0] ?? null;
    };
    $[0] = waveId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== enabled || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: t2,
      enabled,
      staleTime: 120000
    };
    $[3] = enabled;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useQuery(t3);
}

/**
 * Extracts a text preview from drop parts.
 * Concatenates text content from all parts and truncates to maxLength.
 */
export function extractDropPreview(drop: ApiDropWithoutWave | null): ProcessedContent | null {
  if (!drop) return null;
  const textParts = drop.parts.map(part => part.content?.trim()).filter((content): content is string => !!content);
  const combinedText = textParts.join("\n\n");
  const media = drop.parts.flatMap(part => part.media);
  if (!combinedText && media.length === 0) {
    return null;
  }
  return buildProcessedContent(combinedText || null, media, "View drop...");
}